//@flow

import React, { Component } from 'react';

import './switch.css';

type Props = { className: string, on: boolean };
export default class Switch extends Component<Props> {
  render() {
    const { className, on, ...props } = this.props;
    return (
      <div className="item toggle">
        <input className="toggle-input" type="checkbox" />
        <button
          className={`${className} toggle-btn ${on ? 'toggle-btn-on' : 'toggle-btn-off'}`}
          aria-expanded={on}
          {...props}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Preferences/Switch.jsx